module.exports = __webpack_public_path__ + "static/media/header.da34a5f0.png";